module.exports = __webpack_public_path__ + "img/job-dashboard-unselected.aaa6d6fb.svg";